import { Box, CircularProgress, ITheme, Typography, alpha, useTheme } from '@mui/material';
import React from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../store/reducers/store';

const PortfolioProgress: React.FC = () => {
    const { t } = useTranslation();
    const theme = useTheme() as ITheme;
    const portfolio = useAppSelector(state => state.portfolioDetails.portfolio);
    const timeline = useAppSelector(state => state.portfolioDetails.timeline);


    return <Box display={"flex"} flexDirection={"column"} width={"425px"} gap={"30px"} marginTop={"-20px"} marginRight={"15px"} alignItems={"stretch"}>
        {portfolio !== undefined ? <>
            <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} gap={"20px"}>
                <Typography fontSize={"32px"} lineHeight={"39.01px"} fontWeight={"600"}>{portfolio.name}</Typography>
                <Box display={"flex"} flexDirection={"column"}>
                    <Typography fontSize={"65px"} lineHeight={"79.24px"} fontWeight={"500"} textAlign={"right"}>{`${Math.round(100*portfolio.raisedAmount/portfolio.fundraisingTarget)}%`}</Typography>
                    <Typography fontSize={"14px"} lineHeight={"17.07px"} fontWeight={"500"} textAlign={"right"}>{t('PortfolioDetailsCompletedText')}</Typography>
                </Box>
            </Box>
            <Box display={"flex"} flexDirection={"column"} gap={"6px"}>
                <Box width={"100%"} height={"9px"} borderRadius={"10px"} bgcolor={alpha(theme.palette.primary.dark, 0.2)}>
                    <Box width={`${100*portfolio.raisedAmount/portfolio.fundraisingTarget}%`} height={"9px"} borderRadius={"10px"} bgcolor={theme.palette.primary.dark}></Box>
                </Box>
                <Box display={"flex"} justifyContent={"flex-end"} alignItems={"center"} gap={"3px"}>
                    <KeyboardArrowUpIcon sx={{ color: theme.palette.leo.semantic.green}}/>
                    <Typography fontSize={"14px"} lineHeight={"17.07px"} fontWeight={"500"} color={theme.palette.leo.semantic.green}>{`${(100*portfolio.raisedAmountInTime[timeline]/portfolio.fundraisingTarget).toFixed(1)}%`}</Typography>
                </Box>
            </Box>
        </>
            : <Box display={"flex"} justifyContent={"center"} width={"100%"} height={"200px"} alignItems={"center"}><CircularProgress /></Box>}
    </Box>
}

export default PortfolioProgress;